import { createPhotoSwipeLightbox } from '../../lib/photoswipe-lightbox.js'

/** Init PhotoSwipe on a Drive root element (no Stimulus). */
export function initDriveLightbox(root) {
  if (!root) return null
  return createPhotoSwipeLightbox(root)
}
